import React, { Component, } from 'react';
import { string, arrayOf, object, } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Widget from '../../../../legacy-tv-ui/Widget';
import BarChart from '../../../../legacy-tv-ui/BarChart';
import { toPercentage, } from '../../../../utils';
import Footnote from '../../../../components/Footnote';
import Tooltip from '../../../../components/Tooltip';
import IndicatorTable from '../IndicatorTable';

export class BarChartBlock extends Component {
  static propTypes = {
    data: arrayOf(object),
    stackIds: object,
    footnote: string,
  }
  static defaultProps = {
    data: [],
    stackIds: {},
    footnote: '',
  }
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Grid
        item
        xs={12}
        style={{
          padding: 20,
        }}
      >
        <Widget
          title={
            <div>
              各市場預測 - 重要因⼦分佈
              <Tooltip>
                <IndicatorTable />
              </Tooltip>
            </div>
          }
        >
          <BarChart
            formatter={d => toPercentage(d, 0)}
            data={this.props.data}
            stackId={this.props.stackIds}
          />
          {
            this.props.footnote &&
            <Footnote>{this.props.footnote}</Footnote>
          }
        </Widget>
      </Grid>
    );
  }
}

export default BarChartBlock;



// WEBPACK FOOTER //
// ./src/scenes/Prediction/components/BarChartBlock/index.js